import React, { useState, useEffect, Children } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { AxiosInstance } from "../../../../common/Loader/axios.config";

const EditProductModal = ({ isOpen, onClose, selectedProduct, fetchProducts }) => {
    const [formData, setFormData] = useState({
        title: selectedProduct.title,
        description: selectedProduct.description,
        price: selectedProduct.price,
        category: selectedProduct.category,
        children: selectedProduct.children,
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const [allVideos, setAllVideos] = useState([]);

    useEffect(() => {
        async function fetchAllVideos(limit = 50, item = "") {
            let skip = 0;
            let allVideos = [];
            let hasMore = true;

            while (hasMore) {
                try {
                    const fetchedContent = await AxiosInstance.get("/content-videos", {
                        params: {
                            skip,
                            limit,
                            item,
                        },
                    });
                    allVideos.push(...fetchedContent.data.message);
                    skip += limit;
                    hasMore = fetchedContent.data.message.length > 0;
                } catch (error) {
                    console.error("Error fetching content:", error);
                    hasMore = false;
                }
            }
            console.log("All Videos", allVideos);
            setAllVideos(allVideos);
        }

        fetchAllVideos();
    }, []);

    const options = allVideos.map((video) => ({
        value: video._id,
        label: video.title,
    }));

    const [selectedVideos, setSelectedVideos] = useState<string[]>([]);

    const handleVideoChange = (selectedOptions) => {
        let updatedChildren;

        if (Array.isArray(selectedOptions)) {
            const selectedIds = selectedOptions.map(option => option.value);
            setSelectedVideos(selectedIds);

            // Combine existing children with new selected IDs and remove duplicates
            updatedChildren = Array.from(new Set([...formData.children, ...selectedIds]));
            setFormData({ ...formData, children: updatedChildren });
            console.log("Selected Video IDs", selectedIds);
        } else if (selectedOptions) {
            setSelectedVideos([selectedOptions.value]);

            // Combine existing children with the new selected ID and remove duplicates
            updatedChildren = Array.from(new Set([...formData.children, selectedOptions.value]));
            setFormData({ ...formData, children: updatedChildren });
            console.log("Selected Video ID", selectedOptions.value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // setLoading(true);

        const formDataToSend = new FormData();
        for (const key in formData) {
            if (key === 'children') {
                formData[key].forEach(childId => {
                    formDataToSend.append('children[]', childId);
                });
            } else {
                formDataToSend.append(key, formData[key]);
            }
        }

        console.log("Form Data:");
        for (let [key, value] of formDataToSend.entries()) {
            console.log(`${key}:`, value);
        }

        try {
            const response = await AxiosInstance.put(`/${selectedProduct._id}/product`, formDataToSend);
            console.log("Product Update Response", response);

            if (response.data.status === "success") {
                const contentId = response.data.message._id;
                fetchProducts();
                Swal.fire({
                    icon: "success",
                    title: "Product Updated successfully! ",
                    text: `${selectedProduct.title} has been updated successfully!`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                onClose();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to update product",
                    text: `${response.data.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Upload Failed",
                text: "An error occurred while uploading.",
            });
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="relative w-1/2 rounded-lg bg-brand-background p-6">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-2xl text-white"
                >
                    <IoClose />
                </button>
                <h2 className="mb-4 text-lg font-semibold text-white">Edit Product</h2>
                <form
                    onSubmit={handleSubmit}
                    className="flex flex-col gap-4 text-black"
                >
                    <div>
                        <label className="mb-2 block text-white">Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="mb-2 block text-white">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="mb-2 block text-white">Price</label>
                        <input
                            type="text"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                            required
                        />
                    </div>

                    <div className="text-black">
                        <p className="mb-2 block text-white">Children</p>
                        <Select
                            isMulti
                            value={selectedVideos.map((id) => options.find((option) => option.value === id))}
                            onChange={handleVideoChange}
                            options={options}
                            placeholder="Select Video..."
                        />
                    </div>

                    <div>
                        <label className="mb-2 block text-white">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                            required
                        >
                            <option value="">Select Category...</option>
                            <option value="tv">TV</option>
                            <option value="vod">Video</option>
                            <option value="event">Event</option>
                            <option value="shorts">Shorts</option>
                            <option value="series">Series</option>
                        </select>
                    </div>
                    <div className="col-span-2">
                        <button
                            type="submit"
                            className="rounded bg-primary px-4 py-2 text-white"
                        >
                            {loading ? "Updating..." : "Update"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditProductModal;
